import { Flex, Input } from "antd";
import { apiFallBackMsg, useApiCall } from "../services/api";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAuthLogin } from "../redux/auth/loginSlice";
import { useGlobalModal } from "../context/SuccessModalProvider";
import { useEffect, useState } from "react";
import { resendOtpMessage, roleIds, routePrefix, timeLimitForOtp } from "../constant";

const Otp = ({ pageType = "sales" }) => {
  const { postApi, loading } = useApiCall();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { username, type } = useSelector((state) => state.loginData);
  const [timer, setTimer] = useState(timeLimitForOtp);
  const { showPopup } = useGlobalModal();
  const [otpText, setOtpText] = useState("");

  const loginType = location.state?.loginType;
  const email = location.state?.username;
  const forgotType = location.state?.type;

  const actualType = (email || username).includes("@") ? "email" : "phone";

  const onKeyDown = (e) => {
    if (
      ["Backspace", "Tab", "Delete", "ArrowLeft", "ArrowRight"].includes(e.key) ||
      e.ctrlKey ||
      e.metaKey
    ) {
      return;
    }

    if (!/^[0-9]$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const onChange = async (text) => {
    const numericText = text.replace(/\D/g, "");

    setOtpText(numericText);

    if (numericText.length !== 6) return;

    try {
      if (loginType === "resetPassword") {
        const data = {
          type: forgotType,
          username: email,
          otp: numericText,
        };

        const res = await postApi("customer/forgot-password-verify-otp", data, true);

        if (res?.status) {
          navigate(`${routePrefix[pageType]}/forgot-password`, {
            state: { nextPage: true, username: email },
          });
        } else {
          setOtpText("");
        }
      } else {
        const data = {
          type: actualType,
          username,
          otp: numericText,
        };

        const res = await postApi(
          pageType === "customer" ? "customer/login-verify-otp" : "user/singin-verify-otp",
          data,
          true,
        );

        if (res?.status) {
          dispatch(setAuthLogin({ token: res.token, ...res.data }));
          navigate(`${routePrefix[pageType]}/`);
        } else {
          setOtpText("");
        }
      }
    } catch (error) {
      console.error(error);
      setOtpText("");
    }
  };

  const sharedProps = {
    onChange,
    onKeyDown,
  };

  const handleResendOtp = async () => {
    const data = {
      type: actualType,
      username: email || username,
    };
    const res = await postApi(
      pageType === "customer" ? "customer/login-resend-otp" : "user/singin-resend-otp",
      data,
    );
    if (res?.status) {
      if (loginType === "resetPassword") {
        showPopup({
          title: null,
          content: (
            <span className="custom-modal-title">
              Please enter the OTP sent to your {actualType} to complete verification.
            </span>
          ),
          className: "custom-success-modal",
          onOk: () => {},
        });
      } else {
        showPopup({
          title: null,
          content: <span className="custom-modal-title">{res.message}</span>,
          className: "custom-success-modal",
          onOk: () => {},
        });
      }
      setTimer(timeLimitForOtp);
    } else {
      showPopup({
        title: null,
        content: <span className="custom-modal-title">{res?.message || apiFallBackMsg}</span>,
        className: "custom-success-modal",
        onOk: () => {},
      });
    }
  };

  useEffect(() => {
    setTimer(timeLimitForOtp);
  }, [navigate]);

  useEffect(() => {
    if (timer === 0) return;
    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, [timer]);

  return (
    <>
      <div className="container-full">
        <div className="min-h-screen bg-[#A33434] bg-style">
          <div className="min-h-screen flex justify-center items-center">
            <Flex vertical gap={20} className="otp-css">
              <p className="text-[#ffffff] text-3xl font-medium">
                OTP sent to your {actualType}. Please <br /> check your{" "}
                {actualType === "email" ? "inbox" : "messages"}.
              </p>
              <div className="otp-field-wrapper">
                <Input.OTP
                  variant="filled"
                  {...sharedProps}
                  value={otpText}
                  disabled={loading}
                  type="numeric"
                />
              </div>

              {timer > 0 ? (
                <span className="text-white">{resendOtpMessage(timer)}</span>
              ) : (
                <p className="text-[#ffffff] text-base">
                  Didn't receive?{" "}
                  <strong className="cursor-pointer" onClick={handleResendOtp}>
                    Resend OTP.
                  </strong>
                </p>
              )}
            </Flex>
          </div>
        </div>
      </div>
    </>
  );
};

export default Otp;
